import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import uiActions from "../../../../redux/ui/action";
import { url_15_1, url_215 } from "../../../../custom_utilities/api_services";
import { connect } from "react-redux";
import MobileLeftSideBarComponent from "../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import Header_component from "../../structure_components/desktop_screens/header_component/header_component";
import Mobile__right_sideBar_component from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";
import Mobile_header_component from "../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import LoaderPopUp from "../../../../components/loader/loader";
import { useHistory } from "react-router-dom";
import Footer_component from "../../structure_components/desktop_screens/footer_component/Footer_component";
import "./recorded_video_watch_component.scss";
import images from "../../../../utilities/images/images";
import moment from "moment";

const RecordedVideoWatchComponent = (props) => {
  let {
    loader,
    userPreference,
    recordedVideoData,
    userData,
    startLoading,
    finishLoading,
  } = props;

  const history = useHistory();

  const [playbackUrl, setPlaybackUrl] = useState("");
  const [timetableMeta, setTimetableMeta] = useState({
    faculty: "",
    subject: "",
  });

  // `recordedVideoData` can be either:
  // - a string id (old behavior), or
  // - the full schedule element object (new behavior).
  const recordedId =
    recordedVideoData?.rec_id ??
    recordedVideoData?.recId ??
    recordedVideoData?.id ??
    recordedVideoData?.zoom_id ??
    recordedVideoData;

  const facultyName =
    timetableMeta?.faculty ??
    recordedVideoData?.faculty ??
    recordedVideoData?.by_upload ??
    recordedVideoData?.name ??
    recordedVideoData?.trainer ??
    "";

  const subjectName =
    timetableMeta?.subject ??
    recordedVideoData?.meeting_topic ??
    recordedVideoData?.subject ??
    recordedVideoData?.video_description ??
    recordedVideoData?.description ??
    "";

  const headingTitle = playbackUrl?.meeting_topic || subjectName || "";

  useEffect(() => {
    getRecordedLiveClassUrl();
  }, [recordedId]);

  useEffect(() => {
    // Use the same API as "My Schedule" to get reliable faculty + meeting_topic.
    const fetchTimetableMeta = async () => {
      const course_id =
        recordedVideoData?.course_id ??
        recordedVideoData?.meeting_course_id ??
        recordedVideoData?.courseId;
      const batch_id =
        recordedVideoData?.batch_id ??
        recordedVideoData?.meeting_batch_id ??
        recordedVideoData?.batchId;
      const dateStr =
        recordedVideoData?.meetdate ??
        recordedVideoData?.meeting_date ??
        recordedVideoData?.date;
      const recIdLookup =
        recordedVideoData?.rec_id ?? recordedVideoData?.recId ?? recordedId;

      if (!course_id || !batch_id || !dateStr || !recIdLookup) return;

      // API expects full day name (e.g. "Monday")
      const dayStr = recordedVideoData?.day ?? moment(dateStr).format("dddd");

      try {
        const response = await axios.post(url_15_1, {
          course_id,
          batch_id,
          day: dayStr,
          date: dateStr,
        });

        if (response?.data?.status !== 200) return;

        const zoomclassRaw = response?.data?.data?.zoomclass ?? [];
        const zoomclassList = Array.isArray(zoomclassRaw)
          ? zoomclassRaw
          : Object.values(zoomclassRaw || {});

        const found = zoomclassList.find((z) => {
          return z?.rec_id === recIdLookup || z?.recId === recIdLookup;
        });

        if (!found) return;

        setTimetableMeta({
          faculty:
            found?.faculty ??
            found?.by_upload ??
            found?.name ??
            found?.trainer ??
            "",
          subject:
            found?.meeting_topic ??
            found?.subject ??
            found?.video_description ??
            "",
        });
      } catch (e) {
        // non-blocking
        console.log(e);
      }
    };

    fetchTimetableMeta();
  }, [recordedId, recordedVideoData]);

  const getRecordedLiveClassUrl = async () => {
    if (!recordedId) return;
    const data = {
      id: recordedId,
      type: "record",
      isMobile: false,
    };
    startLoading();
    try {
      const response = await axios.post(url_215, data);
      if (response.status === 200) {
        setPlaybackUrl(response.data.data);
        finishLoading();
      } else {
        alert(response.data.message);
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };

  const handleRedirect = () => {
    history.goBack();
  };

  return (
    <Fragment>
      <div className="recorded_video_component_wrapper">
        <div className="recorded_video_component_inner_wrapper">
          {isMob() ? (
            <Fragment>
              <MobileLeftSideBarComponent />
              <Mobile_header_component
                userPreference={userPreference}
                userData={userData}
              />
              <Mobile__right_sideBar_component history={history} />
              <div className="iframe-container">
                <div className="container">
                  <div className="d-flex justify-content-start heading-wrapper">
                    <div className="btn_wrapper">
                      <button onClick={() => handleRedirect()}>
                        <img src={images.user_activity_1} />
                      </button>
                    </div>
                    <div className="text_content_wrapper">
                      <p className="text_content">
                        {headingTitle}
                      </p>
                    </div>
                  </div>
                  <div className="video_frame_wrapper">
                      <iframe
                        id="iframe"
                        src={playbackUrl.playbackurl}
                        title="Live Recorded Video"
                        allow="accelerometer; autoplay; encrypted-media;gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      <div className="recorded_video_meta">
                        {facultyName ? (
                          <div className="recorded_video_meta_line">
                            Faculty: {facultyName}
                          </div>
                        ) : null}
                        {subjectName ? (
                          <div className="recorded_video_meta_line">
                            Subject: {subjectName}
                          </div>
                        ) : null}
                      </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <Header_component />
              <div className="iframe-container">
                <div className="container">
                  <div className="d-flex justify-content-start heading-wrapper">
                    <div className="btn_wrapper">
                      <button onClick={() => handleRedirect()}>
                        <img src={images.user_activity_1} />
                      </button>
                    </div>
                    <div className="text_content_wrapper">
                      <p className="text_content">
                        {headingTitle}
                      </p>
                    </div>
                  </div>
                  <div className="video_frame_wrapper">
                      <iframe
                        id="iframe"
                        src={playbackUrl.playbackurl}
                        title="Live Recorded Video"
                        allow="accelerometer; autoplay; encrypted-media;gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      <div className="recorded_video_meta">
                        {facultyName ? (
                          <div className="recorded_video_meta_line">
                            Faculty: {facultyName}
                          </div>
                        ) : null}
                        {subjectName ? (
                          <div className="recorded_video_meta_line">
                            Subject: {subjectName}
                          </div>
                        ) : null}
                      </div>
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
      <Footer_component />
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
    recordedVideoData: state.userActivity.recordedVideoData,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecordedVideoWatchComponent);
